import React, { useState } from "react";
import UserContext from './UserContext.js';

const UserState = ({children}) => {

    const [user, setUser] = useState();

    const LSuser = JSON.parse(window.localStorage.getItem("usuario"));


  return (
    <UserContext.Provider
        value={{user, setUser, LSuser}}
    >
        {children}
    </UserContext.Provider>
  )
}

export default UserState